/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEvalsDeleteRun } from "../../funcs/llmEvalsDeleteRun.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteEvalRunRequest$inboundSchema,
};

export const tool$llmEvalsDeleteRun: ToolDefinition<typeof args> = {
  name: "llm-evals-delete-run",
  description: `Delete an eval run

Soft-deletes an eval run so it no longer appears in run lists, details, or score leaderboards.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEvalsDeleteRun(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
